import React from "react";
import AsideBase from "./AsideBase";
import {Image, ListGroup} from "react-bootstrap";

import '../../../assets/sass/global/asides/other-teams.scss';
import ShadowScrollbars from "../custom_scrollbars/ShadowScrollbars";

import chelseaLogo from "../../../assets/img/demo/chelsea-logo@24x24.png";
import barcelonaLogo from "../../../assets/img/demo/barcelona-logo@24x24.png";

const teams = [
    {logo: chelseaLogo},
    {logo: chelseaLogo},
    {logo: barcelonaLogo},
    {logo: chelseaLogo},
    {logo: barcelonaLogo},
    {logo: chelseaLogo},
    {logo: chelseaLogo},
    {logo: barcelonaLogo},
    {logo: barcelonaLogo},
    {logo: chelseaLogo},
    {logo: barcelonaLogo},
    {logo: chelseaLogo},
    {logo: barcelonaLogo},
    {logo: barcelonaLogo},
    {logo: chelseaLogo},
    {logo: barcelonaLogo},
];

class OtherTeams extends AsideBase {
    /**
     * Renders the header of the aside component.
     * @returns {React.ReactNode} The aside header.
     */
    renderHeader = () => {
        const {title} = this.props;
        return (
            <div className="title"> {title} </div>
        );
    };

    /**
     * Renders the body of the aside component.
     * @returns {React.ReactNode} The aside body.
     */
    renderBody = () => {
        return this.wrapWithinScrollbar(this.renderTeams());
    };

    /**
     * Wraps the content within scrollbar.
     * @param content {React.ReactNode} The content witch renders within scrollbar.
     * @returns {React.ReactNode} The wrapped component.
     */
    wrapWithinScrollbar = (content) => ShadowScrollbars.wrap(content);

    /**
     * Renders logos of teams.
     * @returns {React.ReactNode} The teams logos.
     */
    renderTeams = () => {
        return (
            <ListGroup variant={null}> {
                teams.map((team, index) => <ListGroup.Item key={index}> <Image className="logo" src={team.logo} roundedCircle onClick={this.handleTeamClick}/> </ListGroup.Item>)}
            </ListGroup>
        )
    };


    handleTeamClick = (event) => {

    };

    asideClasses = () => 'other-players';

    static defaultProps = {
        title: 'Other Teams'
    };
}

export default OtherTeams;
